export enum CardinalDirection {
    N = "N",
    NE = "NE",
    E = "E",
    SE = "SE",
    S = "S",
    SW = "SW",
    W = "W",
    NW = "NW",
}

const directions = [
    { name: CardinalDirection.N, vector: new THREE.Vector3(0, 1, 0) },
    { name: CardinalDirection.NE, vector: new THREE.Vector3(1, 1, 0).normalize() },
    { name: CardinalDirection.E, vector: new THREE.Vector3(1, 0, 0) },
    { name: CardinalDirection.SE, vector: new THREE.Vector3(1, -1, 0).normalize() },
    { name: CardinalDirection.S, vector: new THREE.Vector3(0, -1, 0) },
    { name: CardinalDirection.SW, vector: new THREE.Vector3(-1, -1, 0).normalize() },
    { name: CardinalDirection.W, vector: new THREE.Vector3(-1, 0, 0) },
    { name: CardinalDirection.NW, vector: new THREE.Vector3(-1, 1, 0).normalize() },
];

export const calculateFacadeOrientation = (normal: THREE.Vector3): CardinalDirection => {
    let maxDot = -Infinity;
    let side = CardinalDirection.N;

    for (const { name, vector } of directions) {
        const dot = vector.dot(normal);
        if (dot > maxDot) {
            maxDot = dot;
            side = name;
        }
    }

    return side;
};
